import React, { useContext, useEffect, useRef } from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import DownloadDocumentsToolNav from './DownloadDocumentsToolNav';
import DownloadTokenized from './DownloadTokenized';
import IconButtonWhiteBg from '../../../common/IconButtonWhiteBg';
import IconButtonWithTooltip from '../../../common/IconButtonWithTooltip';
import SvgIconDownload from '../../../../images/icons/Glynt_icon_Download.svg?react';
import { ToolActionsContext } from '../../../../context/ToolActionsContext';

const DivRoot = styled('div')({
  position: 'relative',
});

const PaperStyled = styled(Paper)(() => ({
  position: 'absolute',
  zIndex: 1150,
  right: 'calc(-50% - 3em)',
}));

interface IconDownloadProps {
  review: boolean;
  docLabel: string;
  tokenizerVersion: string | undefined;
  iconType?: 'icon' | 'legacyHeader';
}

const IconDownload: React.FC<IconDownloadProps> = ({
  review,
  docLabel,
  tokenizerVersion,
  iconType = 'icon',
}) => {
  const { setIsReview, setOpen, open } = useContext(ToolActionsContext);
  const paperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsReview(review);
  }, [setIsReview, review]);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (paperRef.current && !paperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setOpen]);

  return (
    <DivRoot ref={paperRef}>
      {iconType === 'legacyHeader' ? (
        <IconButtonWithTooltip
          cypressId="btn-tool-nav-menu"
          icon={<SvgIconDownload style={{ color: '#187787' }} />}
          onClick={() => setOpen(!open)}
          title="Download"
          size={14}
        />
      ) : (
        <IconButtonWhiteBg
          disabled={false}
          onClick={() => setOpen(!open)}
          id="icon-download"
          cypressId="btn-tool-nav-menu"
          tooltip="Download"
          sx={{
            '& svg': { color: 'black' },
            '& svg path': { fill: 'black', stroke: 'black' },
          }}
        >
          <SvgIconDownload style={{ width: '14px', height: '14px' }} />
        </IconButtonWhiteBg>
      )}
      <PaperStyled
        id="tool-actions-menu"
        style={{
          display: open ? 'block' : 'none',
        }}
      >
        <DownloadDocumentsToolNav />
        <DownloadTokenized docLabel={docLabel} tokenizerVersion={tokenizerVersion} />
      </PaperStyled>
    </DivRoot>
  );
};

export default IconDownload;
